import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import img1 from "../../../Assets/Home/img1.png";
import img2 from "../../../Assets/Home/img2.png";
import img3 from "../../../Assets/Home/img3.png";
import image from "../../../Assets/Home/testimonial.png";

const testimonials = [
  {
    id: 1,
    name: "Aarav Sharma",
    role: "Manager",
    feedback:
      "Seasoned professionals with an exceptional understanding of the industry. Understands mining service and quality products are the finest with its great prices!",
    avatars: [img1, img2, img3],
  },
  {
    id: 2,
    name: "Rohan Das",
    role: "Site Engineer",
    feedback:
      "Exceptional quality of work delivered on time with full compliance. Their team handled every challenge with professionalism and precision.",
    avatars: [img2, img3, img1],
  },
  {
    id: 3,
    name: "Priya Patel",
    role: "Operations Head",
    feedback:
      "Their commitment to safety and sustainable mining practices is second to none. Truly a world-class mining services company.",
    avatars: [img3, img1, img2],
  },
  {
    id: 4,
    name: "Ananya Singh",
    role: "Project Coordinator",
    feedback:
      "Highly reliable team with deep technical expertise. Their execution in mining operations exceeded our expectations in every aspect.",
    avatars: [img1, img2, img3],
  },
  {
    id: 5,
    name: "Vikram Mehta",
    role: "Mining Consultant",
    feedback:
      "Professional approach with a strong focus on quality and safety. Their services have significantly improved our project efficiency.",
    avatars: [img2, img3, img1],
  },
  {
    id: 6,
    name: "Sneha Reddy",
    role: "Quality Analyst",
    feedback:
      "Outstanding service and attention to detail. The team ensures every process meets industry standards with consistency.",
    avatars: [img3, img1, img2],
  },
  {
    id: 7,
    name: "Rahul Verma",
    role: "Field Supervisor",
    feedback:
      "Their on-ground team is highly skilled and responsive. They handle complex mining challenges with ease and professionalism.",
    avatars: [img1, img3, img2],
  },
  {
    id: 8,
    name: "Kavita Nair",
    role: "Operations Manager",
    feedback:
      "Impressive commitment to deadlines and operational excellence. One of the most dependable mining service providers we've worked with.",
    avatars: [img2, img1, img3],
  },
];
// const logos = [logo1, logo2, logo3, logo1, logo2];

export default function Testimonial() {
  const [current, setCurrent] = useState(0);

  const prev = () =>
    setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);

  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  const t = testimonials[current];

  return (
    <div className="w-full px-4 sm:px-0 sm:py-12 bg-[#f5f0e8]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="text-xs md:text-sm font-bold font-krona tracking-[0.22em] text-gray-700 uppercase border-b-2 border-[#e8341c] pb-1">
            CUSTOMER STATEMENT
          </span>
          <h2
            className="mt-6 text-gray-900 font-extrabold font-krona text-2xl md:text-4xl lg:text-[45px] "
            style={{ letterSpacing: "-0.02em" }}
          >
            Our client feedback
          </h2>
        </div>

        {/* Body */}
        <div className="flex flex-col md:flex-row items-start gap-12">
          {/* LEFT - AVATARS */}
          <div className="flex flex-col items-center flex-shrink-0 min-w-[200px]">
            <div className="relative flex items-end justify-center mb-4 h-[90px] w-[190px]">
              {/* LEFT */}
              <motion.div
                key={t.avatars[0]}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                className="absolute left-0 bottom-0 rounded-full overflow-hidden border-4 border-[#f5f0e8] z-10 w-[72px] h-[72px]"
              >
                <img
                  src={t.avatars[0]}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </motion.div>

              {/* CENTER */}
              <motion.div
                key={t.avatars[1]}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                className="absolute left-1/2 -translate-x-1/2 bottom-0 rounded-full overflow-hidden border-4 border-[#f5f0e8] z-20 w-[88px] h-[88px]"
              >
                <img
                  src={t.avatars[1]}
                  alt=""
                  className="w-full h-full object-cover"
                />

                {/* Quote badge */}
                <div className="absolute bottom-1 right-1 w-6 h-6 rounded-full bg-[#e8341c] flex items-center justify-center">
                  <span className="text-white text-xs font-black">"</span>
                </div>
              </motion.div>

              {/* RIGHT */}
              <motion.div
                key={t.avatars[2]}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                className="absolute right-0 bottom-0 rounded-full overflow-hidden border-4 border-[#f5f0e8] z-10 w-[72px] h-[72px]"
              >
                <img
                  src={t.avatars[2]}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </motion.div>
            </div>

            <p className="font-extrabold text-gray-900 text-base mt-2 text-center">
              {t.name}
            </p>
            <p className="text-gray-500 text-sm text-center">{t.role}</p>
          </div>

          {/* RIGHT - TEXT */}
          <div className="flex flex-col flex-1">
            {/* ✅ Smooth fade animation */}
            <AnimatePresence mode="wait">
              <motion.p
                key={t.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                className="text-gray-700 text-sm leading-relaxed mb-8 max-w-[580px]"
              >
                {t.feedback}
              </motion.p>
            </AnimatePresence>

            {/* Buttons */}
            <div className="flex gap-3">
              <button
                onClick={prev}
                className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#e8341c] hover:text-[#e8341c]"
              >
                ←
              </button>

              <button
                onClick={next}
                className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#e8341c] hover:text-[#e8341c]"
              >
                →
              </button>
            </div>
          </div>
        </div>

        <div className="mt-10 relative">
          <img
            src={image}
            alt="Mining site"
            className="h-[250px] w-full object-cover rounded-xl"
          />
          <div className="absolute inset-0 bg-black/40 rounded-xl"></div>
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10 text-white">
            <p className="text-sm tracking-widest uppercase text-gray-200">
              Prudence India
            </p>
            <h2 className="mt-2 text-xl md:text-2xl font-bold leading-snug">
              FROM QUARRY TO QUALITY,
            </h2>
            <h2 className=" text-xl md:text-2xl font-bold leading-snug">
              YOUR TRUSTED PARTNER IN MEGA PROJECTS.
            </h2>
            <p className="mt-2 text-sm md:text-base text-gray-200 max-w-md">
              Your trusted partner in delivering large-scale mining and
              infrastructure projects with precision, reliability, and
              excellence.
            </p>
          </div>
        </div>

        {/* LOGO MARQUEE */}
        {/* <div id="contact" className="w-full overflow-hidden py-10 mt-10">
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
            {[...logos, ...logos].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt=""
                className="h-12 md:h-16 lg:h-20 mx-8 opacity-75 hover:opacity-100"
              />
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
}
